import { usePatientProfile } from '@pm/core';
import { useTranslation } from 'react-i18next';

export const useSupportLinks = () => {
  const { isUsaPatient } = usePatientProfile();
  const { t } = useTranslation('global', { keyPrefix: 'SupportLinks' });
  const countryKey = isUsaPatient ? 'USA' : 'Canada';

  return {
    zendesk: {
      home: t(`${countryKey}.ZendeskHome`),
      newRequest: t(`${countryKey}.ZendeskRequest`),
    },
    mailTo: t(`${countryKey}.MailTo`),
    phoneNumber: t(`${countryKey}.PhoneNumber`),
  };
};

export const useInauthSupportLinks = (countryCode: string | undefined) => {
  const isCanadaPatient = countryCode?.toLowerCase() === 'ca';
  const { t } = useTranslation('global', { keyPrefix: 'SupportLinks' });
  const countryKey = isCanadaPatient ? 'Canada' : 'USA';

  return {
    zendesk: {
      home: t(`${countryKey}.ZendeskHome`),
      newRequest: t(`${countryKey}.ZendeskRequest`),
    },
    mailTo: t(`${countryKey}.MailTo`),
    phoneNumber: t(`${countryKey}.PhoneNumber`),
  };
};
